<div class="main-container">
  <div class="button-container">
    <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex" (selectedIndexChange)="onTabChange($event)">
      @for (link of filteredLinks; track trackByIndex($index)) {
        <mat-tab [label]="link.title | translate"></mat-tab>
      }
    </mat-tab-group>
  </div>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
